import { useEffect } from 'react'
import { UseFormSetError } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { PreProcessedPayouts, UpdateFiatPayoutFormPayload } from 'pages/MassPayouts/types'
import { Currencies } from 'types/types'
import { sentenceCase } from 'utils/utils'

const PAYMENT_DISABLED_ERROR = 'Payments to individuals are not enabled for this wallet'

interface UseSetRecordToEditErrors {
  record: PreProcessedPayouts
  walletCurrency: string
  setError: UseFormSetError<UpdateFiatPayoutFormPayload>
  setGeneralError: React.Dispatch<React.SetStateAction<string>>
  setPaymentDisabled: React.Dispatch<React.SetStateAction<boolean>>
}

export const useSetFiatRecordToEditErrors = ({
  record,
  walletCurrency,
  setError,
  setGeneralError,
  setPaymentDisabled,
}: UseSetRecordToEditErrors) => {
  const { t } = useTranslation()

  useEffect(() => {
    const { validationErrors } = record ?? {}

    if (validationErrors?.beneficiary) {
      switch (walletCurrency) {
        case Currencies.EUR:
          setError?.('accountNumber', { message: t('massPayouts.fiatErrors.accountNumberEUR') })
          setError?.('bankCode', { message: t('massPayouts.fiatErrors.bankCodeEUR') })
          break
        case Currencies.GBP:
          setError?.('accountNumber', { message: t('massPayouts.fiatErrors.accountNumberGBP') })
          setError?.('bankCode', { message: t('massPayouts.fiatErrors.bankCodeGBP') })
          break
        default:
          setError?.('accountNumber', {
            message: t('massPayouts.fiatErrors.accountDetailsDefault'),
          })
          setError?.('bankCode', { message: t('massPayouts.fiatErrors.accountDetailsDefault') })
          break
      }
    }
    if (validationErrors?.accountNumber) {
      setError?.('accountNumber', { message: sentenceCase(validationErrors?.accountNumber) })
    }

    if (validationErrors?.bankCode) {
      setError?.('bankCode', { message: sentenceCase(validationErrors?.bankCode) })
    }

    if (validationErrors?.amount || validationErrors?.['amount.value']) {
      setError?.('amount', {
        message: validationErrors?.amount || sentenceCase(validationErrors?.['amount.value']),
      })
    }

    if (validationErrors?.paymentReference) {
      setError?.('paymentReference', { message: sentenceCase(validationErrors?.paymentReference) })
    }

    if (validationErrors?.dateOfBirth) {
      setError?.('dateOfBirth', { message: sentenceCase(validationErrors?.dateOfBirth) })
    }

    if (validationErrors?.general) {
      setGeneralError(validationErrors?.general)
      setPaymentDisabled(validationErrors?.general === PAYMENT_DISABLED_ERROR)
    }
  }, [record?.validationErrors])
}
